


<template>
   
      <div class="py-1 ">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="align-items-center text-center mb-4">
                   <img :src="iconSendEmailPage" class="img-full-width"/>
              </div>
              <div class="align-items-center">
                <p class="mb-0 text-lg text-center text-black">
                 {{ currentMessages.EnterYourEmailTitle }}  </p>
                <p class="mb-0 text-md text-center text-black">
                 {{ currentMessages.TextReceiptNoTitle }}  : {{ receiptStore.receiptsCode }}
                   <!-- {{ receiptStore.receiptsCode }}  -->
                </p>
              </div>
            </div>
            <div class="card-body mt-1">
              <div class="row mb-5">
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >
                    {{ currentMessages.EmailTitle }}
                   </label>
                  <InputText  
                  v-model="emailval" 
                  type="text"
                   placeholder="E-mail" 
                   :class="{ 'is-invalid': emailError }"/>
                </div>
                 <p class="mb-0 text-sm text-left text-black mt-4">
                  {{ currentMessages.EmailDetailTitle }}
                  </p>

              </div>
              <!-- <hr class="horizontal dark" /> -->
               
              <div class="row mb-5">
                  <div class="col-md-6">
                    <GlobalButtonPrv @click="handleClickClear">
                     {{ currentMessages.ButtonClear }}   
                      <i class="fa fa-trash" aria-hidden="true"  style="font-size: 18px; margin-left:5px;"></i>
                    </GlobalButtonPrv>
                  </div>
                  <div class="col-md-6">
                    <GlobalButtonNext :disabled="isSending" @click="handleClickRequestOtp">
                   {{ currentMessages.ButtonSendOTP }}    <i class="fa fa-paper-plane" aria-hidden="true" style="font-size: 18px; margin-left:5px;"></i>
                    </GlobalButtonNext>
                </div>
              </div>
             
               
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-5">
        </div>
      </div>
    </div>

     
    

</template>







<script setup>

import GlobalButtonNext from "@/components/global/GlobalButtonPrimary.vue";
import GlobalButtonPrv from "@/components/global/GlobalButtonGrey.vue";
import InputText from "@/components/global/InputText.vue";
//import { useRouter } from 'vue-router' 
import { useReceiptStoreEtax } from '@/store/useReceiptStoreEtax';
import iconSendEmailPage from '@/assets/img/icons/pages/icon_email.svg';
import { onBeforeMount, onMounted, onBeforeUnmount , computed ,ref ,watch } from "vue";
import { useStore } from "vuex";
//language // 
import messages from '@/locales/messages';
import { useLanguageStore } from '@/store/useLanguageStore';
const languageStore = useLanguageStore();
const currentMessages = computed(() => messages[languageStore.selectedLanguage]);
//End language // 
import { RequestOtpEmail} from '/src/service-api/request-api-etax';

const emit = defineEmits(['next', 'prev', 'sendotp', 'invoice', 'preview', 'submission']);

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// const handleClickRequestOtp = () => {
//   const trimmedEmail = emailval.value.trim();
//   emailError.value = "";

//   // 
//   if (!trimmedEmail) {
//     emailError.value = currentMessages.value.ValidationRequiredEmail || "กรุณากรอกอีเมล";
//     return;
//   }

//   //  
//   if (!emailRegex.test(trimmedEmail)) {
//     emailError.value = currentMessages.value.ValidationInvalidEmail || "รูปแบบอีเมลไม่ถูกต้อง";
//     return;
//   }

//   receiptStore.email = emailval.value;
//   emit('sendotp');
// };


const isSending = ref(false);  // ตัวแปรสถานะ

const handleClickRequestOtp = async () => {
  if (isSending.value) return; // ป้องกันเรียกซ้ำ

  const trimmedEmail = emailval.value.trim();
  emailError.value = "";

  if (!trimmedEmail) {
    emailError.value = currentMessages.value.ValidationRequiredEmail || "กรุณากรอกอีเมล";
    return;
  }

  if (!emailRegex.test(trimmedEmail)) {
    emailError.value = currentMessages.value.ValidationInvalidEmail || "รูปแบบอีเมลไม่ถูกต้อง";
    return;
  }

  try {
    isSending.value = true; 

    const payload = { email: trimmedEmail };
    const response = await RequestOtpEmail(payload);
   // console.log('ส่งเมลสำเร็จ:', response);

    if (response.token) {
      receiptStore.token = response.token;
    }
    receiptStore.email = trimmedEmail;

    emit('sendotp');
  } catch (error) {
    console.error('ส่งเมลล้มเหลว:', error);
    emailError.value = "เกิดข้อผิดพลาดในการส่งอีเมล กรุณาลองใหม่อีกครั้ง";
  } finally {
    isSending.value = false; // จบส่ง
  }
};


const emailval = ref("");
const handleClickClear = () => {
  emailval.value = "";
};

const body = document.getElementsByTagName("body")[0];

const store = useStore();

onMounted(() => {
  store.state.isAbsolute = true;

});
onBeforeMount(() => {
  store.state.imageLayout = "profile-overview";
  store.state.showNavbar = false;
  store.state.showFooter = true;
  store.state.hideConfigButton = true;
  body.classList.add("profile-overview");
});
onBeforeUnmount(() => {
  store.state.isAbsolute = false;
  store.state.imageLayout = "default";
  store.state.showNavbar = true;
  store.state.showFooter = true;
  store.state.hideConfigButton = false;
  body.classList.remove("profile-overview");
});

const emailError = ref('');
watch(emailval, (newVal) => {
  if (emailError.value && newVal?.trim()) {
    emailError.value = '';
  }
});

const receiptStore = useReceiptStoreEtax();

</script>
